import React from 'react';

function CommentSection({
  openAddCommentDialog,
  comments
}) {
  return (
    <div>
      <div style={{ marginLeft: 'auto', marginRight: 'auto', width: 'fit-content', marginTop: '8px' }}>
        <button onClick={openAddCommentDialog}>Add Comment</button>
      </div>

      <div>
        {
          comments !== null && comments !== undefined && comments.length === 0
            ? (
              <div><p>No comments</p></div>
            )
            : (
              comments.map(c => (
                <div key={c.commentId} style={{ marginTop: '8px' }}>
                  <span><strong>{c.createdBy} (Encounter): </strong></span>
                  <span>{c.commentText}</span>&nbsp;
                </div>
              ))
            )
        }
      </div>
    </div>
  );
}

export { CommentSection };
